import React from 'react';

interface SolidColorAvatarProps {
  profileColor: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const SolidColorAvatar: React.FC<SolidColorAvatarProps> = ({ 
  profileColor, 
  size = 'md', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  return (
    <div 
      className={`${sizeClasses[size]} rounded-full border-2 border-gray-200 dark:border-gray-700 shadow-sm ${className}`}
      style={{ backgroundColor: profileColor }}
    />
  );
};

export default SolidColorAvatar;